// extracted by mini-css-extract-plugin
export default {"liconicInstrumentPage":"liconicInstrumentPage-fPHlD","genericInstrumentPage":"genericInstrumentPage-vj2TO","bodyContents":"bodyContents-Gc4UI"};